export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAHUlEQVR42mNgYGD4TyEGEmlp5OFRA0YNoK4BFGAAUAAu4CpeL/MAAAAASUVORK5CYII="